import { FC, useEffect, MouseEvent } from "react";
import { useMutation } from "react-query";
import {
  Button,
  CircularProgress,
  Paper,
  TableContainer,
  Typography,
} from "@mui/material";
import { useForm } from "react-hook-form";
import moment from "moment";
import { expenseListReportService, expenseListReportpdfService,expenseListReportExcelService } from "./service";
import { CustomFormField } from "../../utilis/component/CustomFormElement";
import TableComponent from "../component/TableComponent";
import { clinicId } from "../../constants";
import useRepotFile from "../hooks/reportFileHook";

const BillWiseReport: FC = () => {
  const { control, reset, getValues } = useForm();
  const {
    mutate: searchexpense,
    data: searchData,
    isLoading: searchDataDataLoading,
    reset:resetMutation
  } = useMutation(expenseListReportService);

  const { mutate: getPdf, isLoading: pdfLoading } = useRepotFile({
    apiFunction: expenseListReportpdfService
  });
  const {mutate:getExcel,isLoading:excelLoading}=useRepotFile({apiFunction:expenseListReportExcelService,fileType:"xlsx"})
  const onChange = () => {
    const data = getValues();
    if (data?.fromDate && data?.toDate) {
        searchexpense({ ...data, clinicId });
    }else{
      resetMutation()
    }
  };



  const clearForm = () => {
    reset({
      fromDate: "",
      toDate: ""
    });
    resetMutation()
  }

  useEffect(()=>{
    searchexpense({
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      clinicId
    });

     reset({
          fromDate: moment().format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
        })
  },[])

  const getFiles = (e: MouseEvent<HTMLButtonElement>) => {
    const fileType = e.currentTarget.dataset.filetype;
    const allData = getValues();
    if (fileType === "pdf") {
      getPdf({
        fromDate: allData.fromDate,
        toDate: allData.toDate,
        clinicId,
      });
    }else{
        getExcel({
            fromDate: allData.fromDate,
            toDate: allData.toDate,
            clinicId,
        });
    }
  };

  return (
    <div className="px-3 py-4 flex flex-col gap-3">
      <Paper>
        <div className="p-4 border-b">
          <Typography color={"primary"} fontWeight={600} fontSize={"1rem"}>
            Expense  Report
          </Typography>
        </div>
        <form
          // onSubmit={handleSubmit(onSubmit)}
          className="grid grid-cols-2 gap-3 p-4"
        >
          <CustomFormField
            control={control}
            element="datepicker"
            name="fromDate"
            fieldProps={{ label: "From Date" }}
            rules={{ required: "From Date is required",onChange }}
          />
          <CustomFormField
            control={control}
            element="datepicker"
            name="toDate"
            fieldProps={{ label: "To Date" }}
            rules={{ required: "From Date is required",onChange }}
          />
          <div className="col-span-full flex justify-end items-center gap-3">
            {/* <Button type="submit">search</Button> */}
            <Button color="error" onClick={clearForm}>
              clear
            </Button>
          </div>
        </form>
      </Paper>

      <TableContainer component={Paper}>
        <div className="flex justify-end gap-3 py-2 px-4 border-b">
          <Button
            disabled={
              pdfLoading ||
              searchDataDataLoading ||
              !Boolean(searchData?.response?.length)
            }
            endIcon={pdfLoading && <CircularProgress size={18} />}
            data-filetype="pdf"
            onClick={getFiles}
          >
            pdf
          </Button>

           <Button
              disabled={excelLoading || !Boolean(searchData?.response?.length)}
              endIcon={excelLoading && <CircularProgress size={18} />}
              data-filetype="excel"
              onClick={getFiles} > excel
               </Button>
        </div>
        <TableComponent
          loading={searchDataDataLoading}
          data={searchData?.response || []}
          tableProps={heading}
        />
      </TableContainer>
    </div>
  );
};

export default BillWiseReport;
const heading = [
  { heading: "DATE", key: "date" },
  { heading: "PARTICULARS", key: "particular" },
  { heading: "DESCRIPTION", key: "description" },
  { heading: "INCOME", key: "income" },
  { heading: "EXPENSE", key: "expense" }
];
